export default __webpack_public_path__ + "static/media/sort.520a8eb8.svg";